import { useContext, useEffect } from 'react'
import { AppContext, AppContextType } from '../AppContext'
import { UserContext, UserContextType } from '../UserContext'
import { isMuseDAWBridgeDevice } from './MediaDevices'
import useMediaSelectionActions from '../actions/useMediaSelectionActions'
import usePreviousV2 from '../hooks/usePreviousV2'
import useUserContextRef from './useUserContextRef'

export default function useMuseDAWAudioSelectionManager() {
    // If mediaSources changes, see if there is 'Muse DAW Bridge' there, and
    // set mediaSelection to select it if not done so already.

    const { state: appState } = useContext(AppContext) as AppContextType
    const { state } = useContext(UserContext) as UserContextType

    const { userStateRef } = useUserContextRef()

    const { enableMuseDawBridge, disableMuseDawBridge } = useMediaSelectionActions()

    // function turnOffLocalLoopbackWindows() {
    //     // On Windows, since Muse Audio Share and Muse DAW Bridge are both handled by VB Audio Cable,
    //     // we turn off Local Loopback for VB Audio Cable.
    //     if (env.OS === 'win32') {
    //         MuseAudioShareLocalLoopbackSet(false)
    //     }
    // }

    const mediaSouresPrev = usePreviousV2(state.mediaSources)
    useEffect(() => {
        console.log('useMuseDAWAudioSelectionManager: enableMuseDAWBridge: detected mediaSources changed.')
        if (!userStateRef.current.mediaSelection.isDefaultMediaSelectionLoaded) {
            console.log(
                'useMuseDAWAudioSelectionManager: enableMuseDAWBridge: ...but default is not loaded ' +
                    '(!userStateRef.current.mediaSelection.isDefaultLoaded) so no-op.'
            )
            return
        }

        if (appState.appSettings.alwaysShareMuseDAWBridge) {
            enableMuseDawBridge({ force: true })
        } else {
            // only call if `state.mediaSources`'s Muse DAW Bridge device was newly added.
            if ((mediaSouresPrev.current?.audioInputs || []).find((a) => isMuseDAWBridgeDevice(a)) == null) {
                enableMuseDawBridge()
            } else {
                console.log(
                    'useMuseDAWAudioSelectionManager: enableMuseDAWBridge: audio media source MuseDAWBridge ' +
                        `was not newly added, so no-op.`
                )
            }
        }
    }, [state.mediaSources, appState.appSettings.alwaysShareMuseDAWBridge])

    useEffect(() => {
        if (appState.appSettings.alwaysShareMuseDAWBridge) {
            return
        }

        console.log(
            'useMuseDAWAudioSelectionManager: enableMuseDAWBridge: detected `musePluginState.isConnected` changed.'
        )
        if (!userStateRef.current.mediaSelection.isDefaultMediaSelectionLoaded) {
            console.log(
                'useMuseDAWAudioSelectionManager: enableMuseDAWBridge: ...but default is not loaded ' +
                    '(!userStateRef.current.mediaSelection.isDefaultLoaded) so no-op.'
            )
            return
        }

        if (appState.appState.musePluginState.isConnected) {
            console.log('useMuseDAWAudioSelectionManager: state changed -- musePluginState.isConnected===true')
            enableMuseDawBridge()
        } else {
            console.log('useMuseDAWAudioSelectionManager: state changed -- musePluginState.isConnected===false')
            disableMuseDawBridge()
        }
    }, [appState.appState.musePluginState.isConnected, appState.appSettings.alwaysShareMuseDAWBridge])

    useEffect(() => {
        if (appState.appSettings.alwaysShareMuseDAWBridge) {
            enableMuseDawBridge({ force: true })
        }
    }, [appState.appSettings.alwaysShareMuseDAWBridge])
}
